// store/aggregatedData.js
import Vue from "vue"
import Vapi from "vuex-rest-api"

const aggregatedData = new Vapi({
  axios: Vue.axios,
  queryParams: true,
  state: {
    aggregatedData: null,
  },
})
  .get({
    action: "fetchAggregatedData",
    property: "aggregatedData",
    path: ({ showId }) => `/api/aggregated-data/?show_id=${showId}`,
  })
  .getStore()

export default aggregatedData